import React ,{ useState, useEffect } from 'react';
import './CustomModal.scss'
import { Addresses } from 'utils/Addresses';

interface Props {
    children: React.ReactElement;
    showModal: boolean;
    close: () => void;
    closeAble: boolean;
    maxWidth?: string;
  }

const CustomModal: React.FC<Props> = ({ children, showModal, close, closeAble, maxWidth }) => {
    const [modalCloseAble, setModalCloseAble] = useState<boolean>(true);

    useEffect(() => {
        if (closeAble!==null){
            setModalCloseAble(closeAble)
        }
    }, [])

return showModal ? 
        <div  className="modal-backdrop" onClick={modalCloseAble ?  () => close() : () => null}>
            <div
                style={{maxWidth:maxWidth}}
                className="modal-content"
                onClick={e => {e.stopPropagation();}}
            >
                {
                modalCloseAble ?
                <div className='closeModalParent'>
                    <span onClick={close}>
                    <img src={Addresses.icons.CLOSE_MODAL_X} alt='Close modal' />

                    </span>
                </div>
                :
                null
                }
                {children}
            </div>
        </div>
   : 
        null
    }

  export default CustomModal



// ******HOW TO USE CUSTOM MODAL******

// import CustomModal from '*****/CustomModal'

// const [modalShown, toggleModal] = useState(false);

// <button
    //     onClick={() => {toggleModal(!modalShown);
    //     }}
    // >
//         Toggle Modal
// </button>

{/* <CustomModal
    showModal={modalShown}
    close={() => {toggleModal(false)}}
    closeAble={false} *optional
    maxWidth='500px' *optional
    >
    modal content like :
    <h1>hi</h1>
    <p>this is test</p>
</CustomModal> */}

